<template>
	<drop class="tool-drop"
		:class="{ over, select }"
		:style="`border:3px solid ${paint ? $appColors.success : '#e5e5e5'};`"
		@dragover="over = true"
		@dragleave="over = false"
		@drop="handleDrop"
	>
		<div v-if="!select">
			<p class="text">ARRASTRA AQUÍ ALGUNA HERAMIENTA</p> 
		</div>
		<div v-else class="tool-select">
			<div class="d-flex wrapper-configuration">
				<v-flex xs1>
					<button @click="close">
						<img 
							src="/static/img/close.svg" 
							alt="cerrar"
							height="12px">
					</button>
				</v-flex>
				<v-flex xs3>
					<span
						:style="`color:${$appColors.success};`"
						class="text-green" v-if="false">¡Listo!</span>
				</v-flex>
			</div>
			<div class="wrapper-image">
				<img :src="select.image" :select="select.name">
				<span
					class="text-list"
					:style="`color:${$appColors.info}`"
					:class="{'on' : paint}"
				>
					{{select.name}}
				</span>
			</div>
			<div class="d-flex">
				<v-flex xs6>	
					<hr class="line" :style="`border:1px solid ${$appColors.success};`">
				</v-flex>
				<v-flex xs2>
					<button @click="$emit('configuration', select)" class="btn-conf">
						<img src="/static/img/configuration.svg" alt="configuración" height="18px">
					</button>
				</v-flex>
			</div>
			<div
				class="wrapper-name"
				:class="{'off' : paint}"
				v-if="!paint">
				<p class="tool-select-name"
					:style="`color:${$appColors.info}`"
				>{{select.name}}</p>
			</div>
			<div
				class="wrapper-list"
				:class="{'on' : paint}"
				v-else>
				<v-layout wrap>
					<v-flex
						class="d-flex xs6" 
						v-for="(conf, index) in configurations" 
						:key="index">
						<img 
							:src="conf.image" 
							:alt="conf.name">
						<div>
							<p
								class="text-gray f-14"
								:style="`color:${$appColors.info}`"
							>{{conf.value}}</p>
							<p
								class="text-gray f-10"
								:style="`color:${$appColors.info}`"
							>{{conf.name}}</p>
						</div>
					</v-flex>
				</v-layout>
			</div>
		</div>
	</drop>
</template>

<script>
import { Drop } from 'vue-drag-drop';

function created() {
	if (Object.keys(this.itemSelected).length > 0) {
		this.handleDrop(this.itemSelected);
	}
}

function data() {
	return {
		over: false,
		select: null,
		configurations: [
			{
				name: 'Aplicantes',
				image: '/static/img/diagnosis/app.svg',
				value: 0,
			},
			{
				name: 'Áreas',
				image: '/static/img/diagnosis/areas.svg',
				value: 0,
			},
			{
				name: 'Femenino',
				image: '/static/img/diagnosis/female.svg',
				value: 0,
			},
			{
				name: 'Masculino',
				image: '/static/img/diagnosis/male.svg',
				value: 0,
			},
		],
		paint: false,
	};
}

function handleDrop(item) {
	if (!this.select) {
		const message = `<div class="flex-center"><span>Hacer clic en el botón </span>
											<img src="/static/img/configuration.svg" alt="configuración" height="18px" class="mx-8">
											<span> para configurar herramienta</span></div>`;
		this.over = false;
		this.select = { ...item };
		this.$emit('drop', item);
		this.showNotification(null, 'success', message);
	}
}

function close() {
	this.$emit('close', this.select);
	this.select = null;
	this.paint = false;
}

function list(item) {
	this.resetConfigurationValues();
	if (item.length && this.select) {
		const filter = item.filter(i => i.id === this.select.id);
		this.paint = filter[0].flagConfiguration;
		const saveAreas = filter[0].groups.filter(g => g.selected);
		this.configurations[1].value = saveAreas.length;
		saveAreas.forEach((e) => {
			const selectedEmployees = e.employees.reduce((acc, em) => {
				const newAcc = { ...acc };
				if (em.selected) {
					newAcc.quantity += 1;
					newAcc.female += Number(em.gender === 2);
					newAcc.male += Number(em.gender === 1);
				}
				return newAcc;
			}, { quantity: 0, female: 0, male: 0 });
			this.configurations[0].value += selectedEmployees.quantity;
			this.configurations[2].value += selectedEmployees.female;
			this.configurations[3].value += selectedEmployees.male;
		});
	}
}

function itemSelectedHandler(newItem) {
	if (Object.keys(newItem).length > 0) {
		this.handleDrop(newItem);
	}
}

function resetConfigurationValues() {
	this.configurations[0].value = 0;
	this.configurations[2].value = 0;
	this.configurations[3].value = 0;
}

export default {
	name: 'tool-drop',
	components: {
		Drop,
	},
	created,
	data,
	methods: {
		close,
		handleDrop,
		itemSelectedHandler,
		resetConfigurationValues,
	},
	props: {
		itemSelected: {
			default: () => {},
			type: Object,
		},
		list: {
			type: Array,
			default: () => [],
		},
	},
	watch: {
		itemSelected: {
			deep: true,
			handler: itemSelectedHandler,
		},
		list,
	},
};
</script>
<style lang="scss">
	.tool-drop {
		align-items: center;
		border-radius: 4px;
		border: 1px dashed map-get($colors, border-gray-thin);
		display: flex;
		font-family: map-get($fonts, bold);
		height: 209px;
		justify-content: center;
		margin-bottom: 22px;
		max-height: 209px;
		max-width: 209px;
		transition: all .2s ease-in-out;
		width: 100%;

		&.over {
			border-color: map-get($colors, gray-slider);
		}

		 .text {
			color: color(gray-tabs);
			margin-bottom: 0px;
			text-align: center;
		}

		&.select {
			border: 1px solid map-get($colors, white);
		}

		.wrapper-list {
			opacity: 0;
			transition: all .2s ease-in-out;

			&.on {
				opacity: 1;
			}
		}

		.wrapper-name {
			opacity: 1;
			transition: all .2s ease-in-out;

			&.off {
				opacity: 0;
			}
		}

		.tool-select {
			background: map-get($colors, white);
			height: 100%;
			padding: 10px 26px;
			width: 100%;

			&-name {
				font-size: 16px;
				margin-top: 12px;
				text-transform: uppercase;
			}

			.d-flex {
				align-items: center;
				display: flex;
				justify-content: space-between;
			}

			.line {
				width: 100%;
			}
		}

		.wrapper-configuration {
			margin-bottom: 20px;
		}

		.wrapper-image {
			align-items: center;
			display: flex;
			height: 25px;
		}

		.text-green {
			font-family: map-get($fonts , bold);
			font-size: 15px;
		}

		.flex-center {
			align-items: center;
			display: flex;
			justify-content: center;
		}

		.mx-8 {
			margin: 0 8px;
		}

		.text-list {
			font-size: 11px;
			margin-left: 5px;
			opacity: 0;
			text-transform: uppercase;
			transition: all .2s ease-in-out;

			&.on {
				opacity: 1;
			}
		}

		.text-gray {
			margin: 0 0 0 5px;
		}

		.f-14 {
			font-size: 14px;
		}

		.f-10 {
			font-family: map-get($fonts, regular);
			font-size: 10px;
		}
	}

	.btn-conf {
		position: relative;
		z-index: 5;
	}
</style>




// WEBPACK FOOTER //
// src/components/diagnosis/tool-drop.vue